/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";
import { connect } from "formik";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import { Flex, Box, Text } from "rebass";
import { Button } from "../../../components/Button";
import { Circle } from "../../../components/Circle";
import { ReactComponent as TickIcon } from "./tick.svg";
import { ReactComponent as QuestionMarkIcon } from "./question.svg";
import { PreliminaryEtrLearnMoreLink } from "../../../components/PreliminaryEtrLearnMoreLink/PreliminaryEtrLearnMoreLink";

export class ConfirmationFields extends React.Component {
  static propTypes = {
    isDuplicate: PropTypes.bool,
    match: PropTypes.shape({
      params: PropTypes.shape({
        reportId: PropTypes.string,
      }),
    }).isRequired,
    history: PropTypes.object.isRequired,
    formik: PropTypes.object.isRequired,
  };

  static defaultProps = {
    isDuplicate: false,
  };

  componentDidMount() {
    const {
      formik: { resetForm },
    } = this.props;

    /**
     * ensures that the local state formik values are cleared when successfully
     * submitted which in turns ensures that a user using the Back button can't
     * re-submit the report form with locally stored information.
     *
     * Note that the redux cache (redux-persist) is cleared by the dispatch of
     * the "reportSuccess" action using the forms.reducer
     */
    resetForm();
  }

  handleNext = () => {
    const {
      history,
      match: {
        params: { icpNumber },
      },
    } = this.props;

    history.push(`/address/${icpNumber}`);
  };

  render() {
    const {
      isDuplicate,
      match: {
        params: { reportId },
      },
    } = this.props;

    return (
      <Flex flexDirection="column">
        <Box flex="1 1 0" width={1}>
          <Flex
            flexDirection="column"
            flexWrap="wrap"
            justifyContent="center"
            alignItems="center"
          >
            {/* Content */}
            <Box mt={10}>
              <Circle
                color="white"
                bg={isDuplicate ? "accent" : "secondary"}
                size={90}
              >
                {isDuplicate ? (
                  <QuestionMarkIcon />
                ) : (
                  <TickIcon width="100%" height={40} />
                )}
              </Circle>
            </Box>
            <Box width={1} pt={20} pb={30}>
              <Text textAlign="center" fontSize={5} mb={20} fontWeight="bold">
                {isDuplicate
                  ? `Looks like you have already let us know about this?`
                  : "Thank you for your report."}
              </Text>
              {!isDuplicate && (
                <Flex
                  flexDirection="column"
                  flexWrap="wrap"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Text textAlign="center" fontSize="16px" mb={20}>
                    Our crew will arrive within 75 minutes to investigate. In
                    the absence of severe weather, around 75% of outages are
                    resolved within four hours of the reported time.
                  </Text>
                  <Text textAlign="center" fontSize="16px" mb={20}>
                    Further updates will be provided when the crews are on site.
                  </Text>
                  <Text textAlign="center" fontSize="16px" mb={20}>
                    <PreliminaryEtrLearnMoreLink
                      text="Learn about outage fix times"
                      preliminaryEtrType="Minor"
                    />
                  </Text>
                </Flex>
              )}
              <Text textAlign="center" fontSize="16px" fontWeight="bold">
                Your report ID: {reportId}
              </Text>
              {!isDuplicate && (
                <Text textAlign="center" fontSize="16px">
                  Use this ID for any updates.
                </Text>
              )}
            </Box>
            <Box width={1}>
              <Button variant="dark" block onClick={this.handleNext}>
                View Outage Status
              </Button>
            </Box>
          </Flex>
        </Box>
      </Flex>
    );
  }
}

const enhance = compose(
  withRouter,
  connect, // formik's connect
);

export default enhance(ConfirmationFields);
